import Marquee from "react-fast-marquee";

const ITEMS = [
  { t: "Love Your Internet", c: "text-white/90" },
  { t: "No Contracts", c: "text-white/90" },
  { t: "No Data Caps", c: "text-white/90" },
  { t: "Local Support", c: "text-white/90" },
  { t: "Blazing-Fast Speeds", c: "text-white/90" },
  { t: "Price For Life", c: "text-white/90" },
  { t: "Rural & Proud", c: "text-white/90" },
];

const STAR_COLORS = ["text-cyan-400", "text-pink-400", "text-violet-400", "text-sky-400", "text-fuchsia-400"];

export default function EditorialMarquee() {
  return (
    <div className="py-8 border-y border-white/10 bg-ink-900" data-testid="editorial-marquee">
      <Marquee speed={38} gradient={false} className="overflow-hidden">
        {ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display font-extrabold text-3xl sm:text-5xl tracking-tighter ${item.c} px-8`}>
              {item.t}
            </span>
            <span className={`${STAR_COLORS[i % STAR_COLORS.length]} text-3xl sm:text-5xl`}>✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
